import React, { Component, PropTypes } from 'react';
import { DropTarget } from 'react-dnd';

const weekDayTarget = {
	drop(props) {
		return {
			date: props.date,
			busId: props.busId
		}
	},
	canDrop(props,monitor) {
		const item = monitor.getItem();
		return item.date !== props.date || item.busId !== props.busId;
	}
};

function collect(connect, monitor) {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
		canDrop: monitor.canDrop()
	};
}

class WeekDayDroppable extends Component {
	render() {
		const { external, activeDay, connectDropTarget, isOver, children = [], onClick, isOpen, canDrop } = this.props;

		return connectDropTarget(
			<div className={[
				"camion-dia",
				external ? "external" : "",
				activeDay ? "active-day" : "",
				children.length > 1 ? "multiple" : "",
				!Array.isArray(children) ? "ocupado" : "",
				isOpen ? "isOpen" : "",
				isOver && canDrop ? "isOver" : ""
			].join(" ").trim()} onClick={onClick} ref={this.props.refQ}>
				{children}
			</div>
		);
	}
}

WeekDayDroppable.propTypes = {
	isOver: PropTypes.bool.isRequired
};

export default DropTarget("week_day", weekDayTarget, collect)(WeekDayDroppable);


/** WEBPACK FOOTER **
 ** ./src/components/week_day_droppable.js
 **/